import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

interface EmailVerificationAlertProps {
  error: string | null;
  isVerifying: boolean;
}

export const EmailVerificationAlert = ({ error, isVerifying }: EmailVerificationAlertProps) => {
  if (error) {
    return (
      <Alert variant="destructive" className="mb-4">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription>{error}</AlertDescription>
      </Alert>
    );
  }

  if (window.location.search.includes('type=email') && !isVerifying) {
    return (
      <Alert className="mb-4 border-green-500">
        <CheckCircle2 className="h-4 w-4 text-green-500" />
        <AlertDescription className="text-green-500">
          Email verified successfully! Please sign in.
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};